import React from "react";
import logoImg from "../../../../static/brand/logo-white.svg";
import { Container, Content, LogoContainer, Logo } from "./elements";

const Navbar = () => (
  <Container>
    <Content>
      <LogoContainer>
        <Logo src={logoImg} />
      </LogoContainer>
    </Content>
  </Container>
);

export default Navbar;
